import { action, computed, makeObservable, observable } from 'mobx'
import { IFormStore, ISubFormStore } from './interfaces'
import { clearSubForm, extractSubFormData, isSubFormDirty, validateSubForm } from './subFormHelper'

export class FormStore<T> implements IFormStore<T> {
  stores: Record<keyof T, ISubFormStore<any>> = {} as Record<keyof T, ISubFormStore<any>>

  initialValues: Partial<T> = {}

  constructor(initialValues?: Partial<T>) {
    this.initialValues = initialValues ?? {}
    makeObservable(this, {
      stores: observable,
      initialValues: observable,

      unregister: action,
      register: action,
      setInitialValues: action,

      data: computed,
      isDirty: computed,
    })
  }

  register = <U extends T[keyof T]>(name: keyof T, store: ISubFormStore<U>) => {
    this.stores[name] = store
  }

  unregister = (name: keyof T) => {
    delete this.stores[name]
  }

  validate = () => {
    return validateSubForm(this.stores)
  }

  setInitialValues = (initialValues?: Partial<T>) => {
    this.initialValues = initialValues ?? {}
  }

  clearAll = () => {
    Object.keys(this.stores).forEach(key => {
      clearSubForm(this.stores[key as keyof T])
    })
  }

  get data() {
    return extractSubFormData(this.stores) as T
  }

  get isDirty(): boolean {
    return isSubFormDirty(this.stores)
  }
}
